import { css } from '@emotion/react'

import { colors, typo, whiteAreaCss } from '~/@common/styles'
import { mediaQuery } from '~/@common/styles/mediaQuery'

export const LECTURE_GROUP_CARD_SIZE = 384

export const S = {
  LectureGroup: css`
    ${whiteAreaCss}
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 0 0 ${LECTURE_GROUP_CARD_SIZE}px;
    height: 100%;

    ${mediaQuery.underTablet} {
      flex: 0 0 auto;
      height: auto;
    }

    header {
      display: flex;
      align-items: center;
      padding: 20px 24px;
      color: var(--Colors-Gray-900);
      ${typo.body02};
      font-weight: 600;
    }

    .lecture-group-item-list {
      display: flex;
      flex-direction: column;
      overflow-y: hidden;
      flex: 1 1 auto;
      border-top: 1px solid var(--Colors-Gray-300);
    }

    .lecture-group-item {
      display: block;

      &:hover {
        background-color: var(--Colors-Gray-100);
      }
    }

    .is-active.lecture-group-item {
      background-color: var(--Colors-Blue-50);

      &:hover {
        background-color: var(--Colors-Blue-50);
      }
    }
  `,

  LectureGroupItem: css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 20px 24px;
    color: var(--Colors-Gray-900);
    ${typo.body02};
    cursor: pointer;

    .active-badge {
      display: none;
      gap: 2px;
      flex-shrink: 0;
    }

    .lecture-title {
      flex: 1 1 0;
      min-width: 0;
    }

    .is-active & {
      color: var(--Colors-Blue-600);
      font-weight: 600;

      .active-badge {
        display: inline-flex;
      }

      .lecture-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  `,

  LectureGroupList: css`
    flex: 1 1 auto;

    display: flex;
    gap: 24px;

    scroll-behavior: smooth;
    overflow-y: hidden;
    overflow-x: hidden;

    ${mediaQuery.underTablet} {
      flex-direction: column;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    }
  `,

  Empty: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    gap: 15px;

    .circle {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background-color: rgba(57, 95, 226, 0.5);
      border-radius: var(--Radius-Circle);
    }
    p {
      ${typo.body01};
      color: ${colors.gray.$800};
    }
  `,
}
